import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import { formatNumber, DateFormatter } from '../../utils/date';
import {Link} from 'react-router';
import forEach from 'lodash/forEach';
import Image from '../../components/image/image';
import connect from '../../utils/connect';
import Spinner from '../../components/svg/spinner';
import { fetchContCases } from '../../actions/cases';
import { casesRoute } from '../../routes/index';
import Select from '../form/select/select';
import translate from '../../utils/translate';
import SweetScroll from 'sweet-scroll';
import ContextualCaseSingle from './contextualCaseSingle';

class ContextualCases extends Component {
	static propTypes = {};

	constructor(props) {
		super(props);

		this.state = {
			busy: false,
			searched: false,
			clearCases: false,
			start: 0,
			end: 0,
			active: false,
			searchFocus: false,
		};

		this.cases = [];
		this.years = [];
		this.fetchNext = true;
		this.firstLaunch = true;
	}

	componentWillMount() {
		if (this.props.enableCases) {
			this.fetchContCases = bindActionCreators(fetchContCases, this.props.dispatch);
			this.fetchContCases();
		}

		let startYear = 2000;
		let endYear = new Date().getFullYear();

		let yearsNum = endYear - startYear;

		for (let i = endYear; i >= startYear; i--) {
			let local = {
				label: i,
				value: i,
			};
			this.years.push(local);
		}
	}

	componentWillUnmount() {
		document.querySelector('body').classList.remove('context-active');
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.enableCases !== this.props.enableCases) {
			this.fetchContCases();
		}
	}

	componentWillUpdate(nextProps) {
		this.state.searched = false;

		if (this.props.enableCases) {
			if (this.error || !this.props.cases.contCases || this.state.clearCases || !this.cases.length) {
				let _this = this;
				this.cases = [];
				this.state.clearCases = false;
				this.error = false;

				forEach(nextProps.cases.contCases, function(single) {
					_this.cases.push(single);
				});

			} else if (this.props.enableCases && nextProps.cases.contCases && nextProps.cases.contCases[0].id !== this.props.cases.contCases[0].id) {
				let _this = this;

				forEach(nextProps.cases.contCases, function(single) {
					_this.cases.push(single);
				});
			}
		}

		if (nextProps.cases.error) {
			this.cases = [];
			this.error = true;
			this.cases.push(this.props.cases.error);
		}
	}

	componentDidUpdate() {
		if (this.props.enableCases && this.refs.casesHolder) {
			this.busy = false;
		}

		if (this.refs.casesHolder) {

			let singleCase = document.querySelector('.contextual-menu__inner-list__cases__case');
			let rows = Math.round(this.refs.casesHolder.offsetHeight / singleCase.offsetHeight);
			let columns = parseInt(this.refs.casesHolder.offsetWidth / singleCase.offsetWidth);

			let start = parseInt(this.refs.casesHolder.scrollTop / singleCase.offsetHeight);

			if (start > 1) {
				start *= columns;
			} else if (start == 1) {
				start = columns;
			}

			start += 1;

			let end = start + rows * columns - 1;

			if (this.props.editorials.total < end) {
				end = this.props.editorials.total;
			}

			if (start !== this.state.start || end !== this.state.end) {
				this.setState({
					...this.state,
					start: start,
					end: end,
				});
			}

			if (this.props.browser.window.height > this.refs.casesHolder.offsetHeight && this.fetchNext) {
				setTimeout(() => {
					const domNode = ReactDOM.findDOMNode(this.refs.nextTrigger);
					domNode && domNode.click();
					setTimeout(() => {
						if (this.refs.casesHolder && this.refs.casesHolder.scrollTop) {
							this.refs.casesHolder.scrollTop = 0;
						}
					}, 750);
				}, 500);
				this.fetchNext = false;
			}
		}

		if (this.state.active && this.refs.search && this.firstLaunch && this.props.browser.window.width > 1030) {
			this.refs.search.focus();
			this.firstLaunch = false;
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextState !== this.state ||
			nextProps !== this.props ||
			nextProps.cases.error !== this.props.cases.error ||
			nextProps.cases.contCases.length !== this.props.cases.contCases.length ||
			nextProps.cases.contCases.next !== this.props.cases.contCases.next
		);

		// update on init
		// if ((!this.props.items.length && nextProps.items.length)) {
		// 	return true;
		// }
	}

	render() {
		let nextClass = 'span2 span4-mobile contextual-menu__next';
		let prevClass = 'span2 span4-mobile contextual-menu__prev';
		let toggleClass = 'span2-plus span6-tablet-plus span6-mobile-plus contextual-menu__toggle';
		let buttonClass = 'contextual-menu__toggle__button';
		let innerClass = 'contextual-menu__inner span14';
		let controlClass = 'contextual-menu__control span14';

		if (this.state.active) {
			nextClass = 'span2-plus span4-mobile contextual-menu__next contextual-menu__next--active';
			prevClass = 'span2 span4-mobile contextual-menu__prev contextual-menu__prev--active';
			toggleClass += ' contextual-menu__toggle--active';
			buttonClass += ' contextual-menu__toggle__button--active';
			innerClass += ' contextual-menu__inner--active';
			controlClass += ' contextual-menu__control--active';
		}

		if (this.props.seen || this.state.active) {
			controlClass += ' contextual-menu__control--seen'
		}

		return (
			<section className='contextual-menu span14'>
				<div className={controlClass}>
					<div className='contextual-menu__control__top'>
						{this.props.prev && (
							<Link onClick={(event) => this.onLinkClick(event)} to={casesRoute(this.props.prev)}>
							<div className={prevClass}>
								<span className="contextual-menu__arrow__container">
									<span className='contextual-menu__arrow contextual-menu__arrow--prev'></span>
								</span>
							</div>
							</Link>
						) || (
							<div className={prevClass}>
								<span className="contextual-menu__arrow__container">
									<span className='contextual-menu__arrow contextual-menu__arrow--prev'></span>
								</span>
							</div>
						)}
						<div className='span4 span2-tablet hide-mobile contextual-menu__filler'></div>
						<div className={toggleClass}>
							<button ref='contextualToggle' className={buttonClass} onClick={(event) => this.onClick(event)}>
								<div className='burger-icon'>
									<span><i></i></span>
									<span><i></i></span>
									<span><i></i></span>
								</div>
								<div className='close-icon'>
									<span><i></i></span>
									<span><i></i></span>
								</div>
							</button>
						</div>
						<div className='span4 span2-tablet hide-mobile contextual-menu__filler'></div>
						{this.props.next && (
							<Link onClick={(event) => this.onLinkClick(event)} to={casesRoute(this.props.next)}>
								<div className={nextClass}>
									<span className="contextual-menu__arrow__container">
										<span className='contextual-menu__arrow contextual-menu__arrow--next'></span>
									</span>
								</div>
							</Link>
						) || (
							<div className={nextClass}>
								<span className="contextual-menu__arrow__container">
									<span className='contextual-menu__arrow contextual-menu__arrow--next'></span>
								</span>
							</div>
						)}
					</div>
					{!this.props.seen && (
					<span className='contextual-menu__control__text'>Discover more</span>
					)}
				</div>
				<div ref='contextualInner' className={innerClass}>
				{this.props.cases.contCases && !!this.props.cases.contCases.length && this.props.enableCases && (
					this.renderCases(this.cases)
				) || (this.props.cases.error) && this.props.enableCases && (
					this.renderCases(this.props.cases.contCases)
				) || (
					<Spinner pathStroke='#fff' className='profile-list__table__spinner__spinner' size='80px'></Spinner>
				)}
				</div>
			</section>
		);
	}

	caseScroll(e) {
		let last = e.target.lastChild;
		if (!this.busy) {

			if (e.target.scrollTop - last.offsetTop > -2000) {
				this.busy = true;
				this.casesFetch(e.target.getAttribute('data-href'));
			}
		}

		if (e.target.scrollTop == 0) {
			this.refs.casePrevContainer.classList.add('contextual-menu__arrow__container--inactive');
		} else {
			this.refs.casePrevContainer.classList.remove('contextual-menu__arrow__container--inactive');
		}

		if (!e.target.getAttribute('data-href') && e.target.scrollTop - last.offsetTop > -900) {
			this.refs.caseNextContainer.classList.add('contextual-menu__arrow__container--inactive');
		} else {
			this.refs.caseNextContainer.classList.remove('contextual-menu__arrow__container--inactive');
		}

		let singleCase = document.querySelector('.contextual-menu__inner-list__cases__case');
		let rows = Math.round(e.target.offsetHeight / singleCase.offsetHeight);
		let columns = parseInt(e.target.offsetWidth / singleCase.offsetWidth);

		let start = parseInt(e.target.scrollTop / singleCase.offsetHeight);

		if (start > 1) {
			start *= columns;
		} else if (start == 1) {
			start = columns;
		}

		start += 1;

		let end = start + rows * columns - 1;

		document.querySelector('.contextual-menu__inner-list__right__title').innerHTML = start + ' — ' + end;
	}

	renderCases(cases) {
		let uid = 'contextCases';

		let spinnerClass = 'contextual-menu__inner-list__cases__spinner';

		if (this.state.searched) {
			spinnerClass = 'contextual-menu__inner-list__cases__spinner contextual-menu__inner-list__cases__spinner--active';
		}

		let casesClass = 'contextual-menu__inner-list__cases span14-mobile';
		let rightClass = 'span2-plus contextual-menu__inner-list__right contextual-menu__inner-list__right--date hide-mobile';

		if (this.props.seen || this.state.active) {
			casesClass += ' contextual-menu__inner-list__cases--seen';
			rightClass += ' contextual-menu__inner-list__right--seen';
		}

		return (
			<article key={uid} className='contextual-menu__inner-list span14'>
				<div className='contextual-menu__inner-list__top span14'>
					<h1 className='contextual-menu__inner-list__top__title'>Winners</h1>
					<span className='contextual-menu__inner-list__top__number'> ({this.props.cases.totalCases})</span>
				</div>
				<div className='contextual-menu__inner-list__filters span4-plus span6-tablet-plus span14-mobile-plus'>
					<Select
						onChange={(event) => this.dateInput(event)}
						name=''
						ref='monthInput'
						placeholder='Month'
						className='contextual-menu__inner-list__filters__filter contextual-menu__inner-list__filters__filter--month'
						options={[{label: 'January', value: 1,},{label: 'February', value: 2,},{label: 'March', value: 3,},{label: 'April', value: 4,},{label: 'May', value: 5,},{label: 'June', value: 6,},{label: 'July', value: 7,},{label: 'August', value: 8,},{label: 'September', value: 9,},{label: 'October', value: 10,},{label: 'November', value: 11,},{label: 'December', value: 12,}]} />
					<Select
						onChange={(event) => this.dateInput(event)}
						name=''
						ref='yearInput'
						placeholder='Year'
						className='contextual-menu__inner-list__filters__filter contextual-menu__inner-list__filters__filter--year'
						options={this.years} />
				</div>
				<input ref='search' onFocus={() => this.setState({...this.state, searchFocus: true})} onBlur={() => this.setState({...this.state, searchFocus: false})} className='contextual-menu__inner-list__search span8 hide-mobile' type='text' onInput={(event) => this.caseSearch(event)} placeholder={translate('contextual/caseSearch')}/>
				{!this.state.searchFocus && (
				<div className="contextual-menu__inner-list__search__cursor"></div>
				)}
				<ul ref='casesHolder' className={casesClass} onScroll={(event) => this.caseScroll(event)} data-href={this.props.cases.next}>
					<li ref='profileSpinner' className={spinnerClass}>
						<Spinner pathStroke='#fff' className='profile-list__table__spinner__spinner' size='80px'></Spinner>
					</li>
					{this.cases.map((single, i) => this.renderSingleCase(single,i))}
					{this.props.cases.next && (
						<li ref='loadMoreSpinner' className='contextual-menu__inner-list__load-more'>
							<Spinner pathStroke='#fff' className='contextual-menu__inner-list__load-more__spinner' size='40px'></Spinner>
						</li>
					)}
				</ul>
				<div className={rightClass}>
					<span className='contextual-menu__inner-list__right__byline'>showing</span>
					<h2 className='contextual-menu__inner-list__right__title'>{this.state.start + ' — ' + this.state.end}</h2>
					<span className='contextual-menu__inner-list__right__number'>{'of ' + this.props.cases.total}</span>
					<nav className='contextual-menu__inner-list__right__nav'>
						<a href='#' onClick={(event) => this.casesNavPrev(event)} className='contextual-menu__inner-list__right__nav__prev'>
							<span ref='casePrevContainer' className="contextual-menu__arrow__container">
								<span className='contextual-menu__inner-list__right__nav__arrow contextual-menu__inner-list__right__nav__arrow--inactive'></span>
							</span>
						</a>
						<a href='#' onClick={(event) => this.casesNav(event)} className='contextual-menu__inner-list__right__nav__next' ref='nextTrigger'>
							<span ref='caseNextContainer' className="contextual-menu__arrow__container">
								<span className='contextual-menu__inner-list__right__nav__arrow'></span>
							</span>
						</a>
					</nav>
				</div>
			</article>
		);
	}

	renderSingleCase(single, i) {
		let uid = 'contextualCase-' + i;
		return (
			<ContextualCaseSingle key={uid} case={single} id={i} browser={this.props.browser} onClick={() => this.onLinkClick()} />
		)
	}

	hasClass(element, cls) {
		return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	}

	casesFetch(href) {
		if (href) {
			let parameters = href;

			parameters = parameters.split('/');
			parameters = parameters[parameters.length - 1];

			parameters = parameters.split('&');

			let offset = parameters[0].split('=')[1];

			let limit = parameters[1].split('=')[1];

			let month = null;
			if (parameters[2]) {
				month = parameters[2].split('=')[2];
			}

			let year = null;
			if (parameters[3]) {
				year = parameters[3].split('=')[3];
			}

			let query = '';
			if (parameters[4]) {
				query = parameters[4].split('=')[4];
			}

			this.offset = offset;
			this.limit = limit;

			this.fetchContCases(offset, limit, this.month, this.year, this.query);
		} else {
			console.log('Tried to caseFecth(null) - contextualCase:267');
		}
	}

	dateInput(e) {
		this.month = this.refs.monthInput.value;
		this.year = this.refs.yearInput.value;
		this.refs.casesHolder.scrollTop = 0;

		this.fetchContCases(0, 36, this.month, this.year, this.query);
		this.setState({
			...this.state,
			searched: true,
			clearCases: true,
		});
	}

	caseSearch(e) {
		e.preventDefault();

		let state = this.state.searched;
		let _this = this;
		this.query = e.target.value;
		let m = this.refs.monthInput.value;
		let y = this.refs.yearInput.value;

		clearTimeout(this.inputTimeout);

		this.refs.casesHolder.scrollTop = 0;

		this.inputTimeout = setTimeout(function() {
			_this.fetchContCases(0, 36, m, y, _this.query);
			_this.setState({
				...this.state,
				searched: true,
				clearCases: true,
			});
		}, 400);
	}

	casesNavPrev(e) {
		e.preventDefault();

		if (this.refs.casesHolder) {
			const scroller = new SweetScroll({ easing: 'easeOutQuint', offset: -60, duration: 700 }, this.refs.casesHolder);
			scroller.to("-=" + this.refs.casesHolder.offsetHeight);
		}


		//this.refs.casesHolder.scrollTop = this.refs.casesHolder.scrollTop - this.refs.casesHolder.offsetHeight;
	}

	casesNav(e) {
		e.preventDefault();

		//this.refs.casesHolder.scrollTop = this.refs.casesHolder.lastChild.previousSibling.offsetTop;
		if (this.refs.casesHolder) {
			const scroller = new SweetScroll({ easing: 'easeOutQuint', offset: -60, duration: 700 }, this.refs.casesHolder);
			scroller.to("+=" + this.refs.casesHolder.offsetHeight);

			this.casesFetch(this.refs.casesHolder.getAttribute('data-href'));
		}
	}

	onLinkClick(e) {
		document.querySelector('body').classList.remove('context-active');

		this.setState({
			...this.state,
			active: false,
		});
		try {
			localStorage.setItem('context', 'seen');
		} catch (e) {}
	}

	onClick(e) {
		e.preventDefault();
		document.querySelector('body').classList.toggle('context-active');

		try {
			localStorage.setItem('context', 'seen');
		} catch (e) {}

		this.setState({
			...this.state,
			active: !this.state.active,
		});
	}
}

export default connect(ContextualCases);



/** WEBPACK FOOTER **
 ** ./frontend/components/contextual/contextualCases.js
 **/